export default class NoticeTypeDomainService {
    static get populationShare() {
        return 1;
    }
}
